export default {
  async actionGetToastNotification({ commit }) {
    const response = await this.$services._core.notification().getAllNotification({
      page        : 1,
      perPage     : 5,
      displayMode : "toast",
      isRead      : false
    });
    commit('ADD_NOTIFICATIONS', response.data.results.map(notification => ({
      ...notification,
      description: notification.message
    })));
  },
  async actionReadNotification({ commit }, { notificationId, recipientId }) {
    commit('REMOVE_NOTIFICATION', notificationId);
    this.$services._core.notification().updateNotificationRecipients(recipientId, { isRead: true });
  }
};